import React, { useState, useMemo, useCallback, useEffect } from 'react';
import auth from '../services/Auth/Firebase';

import {
  AuthContextValue,
  AuthProviderPropsInterface,
} from './AuthContext.types';

export const AuthContext = React.createContext<AuthContextValue>({
  isSignedIn: false,
  mfaEnrolled: false,
  currentUser: null,

  update: () => {},
});

export const AuthProvider = ({ children }: AuthProviderPropsInterface) => {
  const [loaded, setLoaded] = useState(false);

  const [isSignedIn, setSignedIn] = useState(!!auth.currentUser);
  const [currentUser, setCurrentUser] = useState(auth.currentUser);
  const [mfaEnrolled, setMfaEnrolled] = useState(false);

  const update = useCallback((user: any) => {
    setSignedIn(!!user);
    setCurrentUser(user);
    setMfaEnrolled(user?.multiFactor?.enrolledFactors?.length > 0);
  }, []);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      update(user);
      setLoaded(true);

      if (process.env.NODE_ENV === 'development') {
        const token = await user?.getIdToken();
        console.log(token);
      }
    });

    return unsubscribe;
  }, [update]);

  const value = useMemo(
    () => ({
      isSignedIn,
      currentUser,
      mfaEnrolled,

      update,
    }),
    [isSignedIn, currentUser, mfaEnrolled, update],
  );

  if (!loaded) {
    return null;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
